module.exports = __webpack_public_path__ + "static/media/hero-onground-1.7f12df22.png";